import { render, staticRenderFns } from "./personalSign.vue?vue&type=template&id=22dba6d3&scoped=true"
import script from "./personalSign.vue?vue&type=script&lang=js"
export * from "./personalSign.vue?vue&type=script&lang=js"
import style0 from "./personalSign.vue?vue&type=style&index=0&id=22dba6d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dba6d3",
  null
  
)

export default component.exports